export const categoryCardBgColors = ['blue.100', 'purple.300', 'tomato'];

export const brandsCardBgColors =  ['orange.100', 'green.100', 'pink.100'];
